import { FC, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useIsClient } from 'usehooks-ts';

import { LIVE_CHAT_TEST_IDS } from '../lib/testIds';

/**
 * Creates a portal at the top of window.parent's <body> for inserting keyboard accessible "skip to" link
 */
export const SkipLinkPortal: FC<React.PropsWithChildren> = ({ children }) => {
  const [portalElement] = useState(() => {
    const element = window.parent.document.createElement('div');
    element.id = LIVE_CHAT_TEST_IDS.SKIP_LINK;
    return element;
  });

  useEffect(() => {
    window.parent.document.body.prepend(portalElement);
    return () => portalElement?.remove();
  }, [portalElement]);

  // Avoid SSR
  const isClient = useIsClient();
  return isClient ? ReactDOM.createPortal(children, portalElement) : null;
};

SkipLinkPortal.displayName = 'SkipLinkPortal';
